import { SettingsRowCombinedProps } from './types';

const usePresenter = (props: SettingsRowCombinedProps): SettingsRowCombinedProps => {
  return props;
};

export default usePresenter;
